var map = {
	"./admin/reducer.js": 374,
	"./album/reducer.js": 562,
	"./announcement/reducer.js": 560,
	"./class/reducer.js": 387,
	"./customer/reducer.js": 388,
	"./homework/reducer.js": 555,
	"./organization/reducer.js": 389,
	"./posts/reducer.js": 390,
	"./resource/reducer.js": 391,
	"./school/reducer.js": 553,
	"./sessions/reducer.js": 392,
	"./teacher/reducer.js": 393,
	"./user/reducer.js": 394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 373;